export interface Settings {
  soundEnabled: boolean;
  reducedMotion: boolean;
}

const KEY = 'phermon.settings.v1';

export function loadSettings(): Settings {
  const defaults: Settings = {
    soundEnabled: true,
    reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  };
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return defaults;
    const value = JSON.parse(raw) as Partial<Settings>;
    return {
      soundEnabled: typeof value.soundEnabled === 'boolean' ? value.soundEnabled : defaults.soundEnabled,
      reducedMotion: typeof value.reducedMotion === 'boolean' ? value.reducedMotion : defaults.reducedMotion,
    };
  } catch {
    return defaults;
  }
}

export function saveSettings(settings: Settings): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(settings));
  } catch {
    // Private browsing and full storage must not prevent play.
  }
}
